import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import { onRequestMade } from '../../common/analytics';
import { useCommonContext } from '../product-router/product/result-provider/analytics/product-state-analytics/use-product-state-analytics';
export var useDecorateWithTimings = function useDecorateWithTimings() {
  var _useCommonContext = useCommonContext(),
    _useCommonContext2 = _slicedToArray(_useCommonContext, 5),
    fireAnalyticsEvent = _useCommonContext2[0],
    activeProduct = _useCommonContext2[1],
    isExpanded = _useCommonContext2[2],
    isMultiProduct = _useCommonContext2[3],
    filters = _useCommonContext2[4];
  var decorateWithTimings = useCallback(function (postQueryItemSupplier) {
    return function (args) {
      var start = new Date();
      return postQueryItemSupplier(args).then(function (result) {
        var end = new Date();
        var postQueryRequestDurationMs = end.getTime() - start.getTime();
        fireAnalyticsEvent(onRequestMade({
          actionSubjectId: 'postQuerySearchResults',
          timings: {
            postQueryRequestDurationMs: postQueryRequestDurationMs
          },
          activeProduct: activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id,
          isExpanded: isExpanded,
          isMultiProduct: isMultiProduct,
          filters: filters
        }));
        return result;
      });
    };
  }, [fireAnalyticsEvent, activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id, isExpanded, isMultiProduct, filters]);
  return decorateWithTimings;
};